export const SAMPLE_SCHEMA =
  '{"type":"object","required":["symbol","price","slot"]}';
export const SAMPLE_SLICE_20 = '{"symbol":"BTC-USD","price":65000,"slot":20}';
export const SAMPLE_SLICE_10 = '{"symbol":"BTC-USD","price":64000,"slot":10}';
